import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css'; 
import { useQuery, useQueryClient } from '@tanstack/react-query';
import API_URL from './api/config';

function SignupNoTotem() {
    const navigate = useNavigate();
   
   
    const [totemName, setTotemName] = useState('');
  const [imageFile, setImageFile] = useState(null); // optional image

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file); // Store it optionally
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        document.getElementById("blah").src = e.target.result;
      };
      reader.readAsDataURL(file);
    }
  };

  const handleTotemSubmit = async () => {
    if (!totemName.trim()) {
      toast.error("Please enter your totem name.");
      return;
    }

    const formData = new FormData();
    formData.append("clan_name", totemName);
    if (imageFile) {
      formData.append("image", imageFile); // Only if selected
    }

    try {
      const res = await axios.post(`${API_URL}/reg-signup-nototem-api`, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      if (res.data.Status === "Success") {
        navigate(res.data.redirect);
      } else {
        toast.error(res.data.Message || "Failed to register clan.");
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong.");
    }
  };


    return (

         <div class="row" style={{marginTop: '5%'}}>
              <ToastContainer />
                  <div class="col-md-3">
                      
                  </div>
              
                  <div class="col-md-6">
              
                  <div class="card border-0 shadow col-md-6 bg-secondary text-white">
                      <div class="card-body">
                          <p class="h4 text-center">You can register your new totem here.</p>
                        
                              
                          <div class="row g-3 align-items-end">
              
                              <div class="col-6 vstack gap-3">

                              <center>
            <div className="profile-pic-wrapper " style={{ marginTop: "20%" }} >
              <label
                htmlFor="avatar_upload"
                className="avatar avatar-xxl profile-cover-avatar-square"
                style={{
                  height: "162px",
                  width: "162px",
                  position: "relative",
                  cursor: "pointer",
                  display: "inline-block",
                }}
              >
                <img
                  id="blah"
                  src="#"
                  alt="Upload Preview"
                  className="avatar-img"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                    
                  }}
                />
                <input
                  type="file"
                  name="image"
                  id="avatar_upload"
                  accept="image/*"
                  style={{ display: "none" }}
                  onChange={handleImageChange}
                />
                <span
                  className="avatar-edit"
                  style={{
                    position: "absolute",
                    bottom: "5px",
                    right: "5px",
                    backgroundColor: "#184A2C",
                    color: "#fff",
                    borderRadius: "50%",
                    padding: "8px",
                  }}
                >
                  <i className="fas fa-edit avatar-uploader-icon shadow-soft"></i>
                </span>
              </label>
              
              
              
            </div>

            <label>Upload Totem (optional)</label>
          </center>

                                  <div class="">
                                      <label for="account" class="form-label"> Enter Your Totem</label>
                                      <input
                                          type="text"
                                          name="totem_name"
                                          id="totem_name"
                                          className="form-control"
                                          required
                                          value={totemName}
                                          onChange={(e) => setTotemName(e.target.value)}
                                        />
                                  </div>
                                  
                              </div>
              
                              <div class="col-12 mb-3">
                              <div class="d-flex justify-content-between">
        
                                  <Link onClick={() => navigate(-1)} class="btn btn-back">Back</Link> 
                                  
                                  <button onClick={handleTotemSubmit} class="btn btn-primary" type="submit">Continue</button>
        
                              </div>
                          </div>
              
                          </div>
              
                          
                      </div>
                  </div>
              </div>
              
              <div class="col-md-3">
                      
                  </div>
              
              
              </div>



    );
}

export default SignupNoTotem;
